<template>
  <figure  v-bind:class="[dataType]" v-if="dataSource === 'id'"
    :style="`--data-height:${defaultHeight}`"
  >
    <picture  v-if="imageUrl" 
      v-bind:class="[dataType]"
     :style="`background-image: url(${imageUrl})`"
      ><!-- :style="`--image-show:url('${imageUrl}')`" -->
      <source v-if="imageArray['thumbnail']" media="(max-width: 420px)" :srcset="imageArray['thumbnail'].source_url">
      <source v-if="imageArray['medium']" media="(max-width: 680px)" :srcset="imageArray['medium'].source_url">
      <source v-if="imageArray['large']" media="(min-width: 1024px)" :srcset="imageArray['large'].source_url">
      <source v-if="imageArray['full']" media="(min-width: 1440px)" :srcset="imageArray['full'].source_url">
      <img :src="imageUrl" v-if="dataType === 'image'" :title="title" :alt="altText" > 
    </picture>
    <slot></slot>
    <figcaption
      v-if="showCaption"
    >
      <span class="title"  v-if="dataType !== 'featuredImage'" v-html="title"></span>
      <span class="caption"  v-if="dataType !== 'featuredImage'" v-html="caption"></span>
      <slot name="message" v-if="dataType === 'featuredImage'">
      </slot>
    </figcaption>
  </figure>
  <!--  v-lazy:background-image="imageUrl" -->
  <figure v-else-if="ready"
   v-bind:class="[dataType]"
   :style="`--data-height:${defaultHeight}`" >
    <picture
      v-bind:class="[dataType]"
      :style="`backgroundImage:url(${imageUrl})`"
     
    >
        <img v-if="dataType === 'image'" :src="imageUrl">
    </picture>
  </figure>
</template>

<script>
//import contentService from '@/services/contentService'
import axios from 'axios'
const endpoint  = `https://members.eccourts.org`
const getImage = (id, axiosSource) => {
    const url = `${endpoint}/wp-json/wp/v2/media/${id}?_fields=id,caption,sizes,media_details,title,source_url,alt_text`
    return axios.get(url, { cancelToken: axiosSource.token })
  }
import {mapState} from 'vuex'
export default {
props:{
  dataSource: {
    type: String,
    default:'id'
  },
  sourceUrl: {
    type: String,
  },
  dataType :{
    type: String,
    default: 'image'
  },
  showCaption: {
    type: Boolean,
    default: true
  },
  defaultHeight:{
    type: String,
    default: ' '
  },
  dataId: {
    type: [Number, String]
  },
  dataSize: {
    type: String,
  }
},
name: 'imageComponent',
data () {
  return {
      ready: false,
      requests: [],
      request: null,
      imageUrl:'',
      imageArray: [],
      altText:'',
      caption:'',
      title:'',
  }
},
mounted(){
 if( this.dataSource === 'id') {
    this._getImage()
 } else {
    this.imageUrl = this.sourceUrl
    setTimeout(() => {
      this.ready = true
    }, 300);
 }
},
beforeDestroy() {
/*   this.request !== null 
  ? this.cancel()
  : '' */
},
  computed: {
    ...mapState({
      images: state => state.images
    })
  },
methods: {
  clearOldRequest() {
    this.requests.push(this.request);
    this.request = null;
  },
  cancel() {
    this.request.cancel()
    this.clearOldRequest()
  },
  _getImage () {
    let record = -1
    if (record > -1) {
      let result = {
        data: this.images[record]
      }
          this.imageArray = result.data.media_details.sizes
          this.altText = result.data.alt_text
          this.caption = result.data.caption.rendered
          this.title = result.data.title.rendered
          try{
            if(this.dataSize) this.imageUrl = result.data.media_details.sizes[`${this.dataSize}`].source_url
            else this.imageUrl = result.data.media_details.sizes['large'].source_url
          }
        catch(err){
          if(err)this.imageUrl = result.data.source_url
        }   
    }
  /*   if (this.request) this.cancel() */
      else this._fetchImage()
  },
_fetchImage () {
    if(this.dataId) {
      const axiosSource = axios.CancelToken.source()
      this.request = { cancel: axiosSource.cancel}
      getImage(this.dataId, axiosSource)
        .then((result) => {
        //  this.$store.commit('ADD_IMAGE', result.data)
          this.imageArray = result.data.media_details.sizes
          this.altText = result.data.alt_text
          this.caption = result.data.caption.rendered
          this.title = result.data.title.rendered
          try{
            if(this.dataSize) this.imageUrl = result.data.media_details.sizes[`${this.dataSize}`].source_url
            else this.imageUrl = result.data.media_details.sizes['large'].source_url
          }
        catch(err){
          if(err)this.imageUrl = result.data.source_url
        }    
      })
      .catch(err =>{
        if(err) window.console.log('aborting')
      })
    }
  },
}
}
</script>

<style lang="scss" scoped>
figure {
  margin: 0px;
  position: relative;
    &.featuredImage {
      width: 100%;
      height: 100%;
       &::before {
        position: absolute;
        content: ' ';
        width: 100%;
        height: 50%;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.86), transparent);
        bottom: 0;
        left: 0;
      }
    }
    &.background {
        height:100%;
      &::before {
        position: absolute;
        content: ' ';
        width: 100%;
        height: 50%;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.86), transparent);
        bottom: 0;
      }
    }
    &.special_bg {
      height: 100%;
    }
    picture {
    &.special_bg {
      background: var(--image-show);
      background-size: cover !important;
      width: 100%;
      background-position: center center;
      background-repeat: no-repeat;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    }

  figcaption {
    position: absolute;
    bottom: 0;
    z-index: 9;
    width: 100%;
    padding: 16px;
    left: 0;
    color: white;
  }
  &.card-background {
    height: 100%;
    picture {
      display: inherit;
      margin: 0;
      line-height: 1;
      max-width: 100%;
      background-size: cover;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
    }
  }
}
picture {
  display: inherit;
  margin: 0;
  line-height: 1;
  max-width: 100%;
  &.background {
    background: var(--image-show);
    background-size: cover !important;
    width: 100%;
    background-repeat: no-repeat;
    height: 100%;
    min-height: 330px;
    @media screen and (min-width: 1024px) {
      min-height: 440px;
    }
     img {
       opacity: 0;
     }
  }
  &.featuredImage {
    background: var(--image-show);
    background-size: cover !important;
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    height: 100%;
     img {
       opacity: 0;
       display: none;
     }
  }
  img {
    max-width: 100%;
  }
}
</style>
